import { Stack } from "@mantine/core";
import { TinyEpisodeListItem } from "./TinyEpisodeListItem";

export function PopularEpisodes({ episodes }: { episodes: Episode[] | undefined }) {
    if (!episodes) {
        return null;
    }
    return (
        <Stack gap="sm">
            {episodes.map((episode) => {
                return episode.podcast ? (
                    <TinyEpisodeListItem
                        key={`popular-episode-${episode.id}`}
                        episode={episode}
                        podcast={episode.podcast}
                    />
                ) : null;
            })}
        </Stack>
    );
}
